import { RulesComponentController } from './rules-component.controller';
import { RulesComponentProps } from './rules-component.model';

export const RulesComponent = (props: RulesComponentProps) => {
  return <RulesComponentController {...props} />;
};

export { getOnAddRuleFunc, getOnRemoveRuleFunc } from './helpers/hook-form';
